<div class="header mat-elevation-z2">
  <ng-container *ngIf="!sourcesSelection.hasValue() || isShowArchived; else multiselectHeader">
    <div class="add-source">
      <button
        [disabled]="!getIsCreatePermissionsAllowed()"
        (click)="actionAdd()"
        class="add-source-button"
        mat-raised-button
        color="success"
      >
        {{ "sources.listTable.topBar.addSource" | translate }}
      </button>
    </div>

    <mat-form-field class="search">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [formControl]="searchControl" placeholder="{{ 'system.search' | translate }}"/>
      <button *ngIf="isSearchFieldValue" mat-button class="clear-search" matSuffix matTooltip="Clear"
              (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div class="show-archived">
      <mat-slide-toggle color="primary" (change)="onShowArchived($event)" [disabled]="isDataLoading"
                        [checked]="isShowArchived"
      >{{ "system.showArchived" | translate }}
      </mat-slide-toggle>
    </div>
  </ng-container>

  <ng-template #multiselectHeader>
    <div class="multiselect-header">
      <div class="one-item-selected">
        <mat-icon (click)="clearAllSelectedSources()">close</mat-icon>
        <p class="text">
          {{ sourcesSelection.selected.length }}

          <ng-container *ngIf="sourcesSelection.selected.length === 1; else plural">
            {{ "devices.ItemSelected" | translate }}
          </ng-container>

          <ng-template #plural>
            {{ "devices.ItemsSelected" | translate }}
          </ng-template>
        </p>
      </div>

      <div class="action-buttons">
        <a
          *ngIf="sourcesSelection.selected.length === 1 && isEditActionAvailable(sourcesSelection.selected[0])"
          mat-button
          color="primary"
          class="menu-item-href edit"
          (click)="actionEdit($event, sourcesSelection.selected[0])"
          [routerLink]="getEditRouterLink(sourcesSelection.selected[0])"
        >
          <mat-icon>edit</mat-icon>
          {{ "system.edit" | translate }}
        </a>

        <button *ngIf="isCompanyAdmin()" (click)="addToCategory()" mat-button color="primary" class="edit">
          <mat-icon>folder</mat-icon>
          {{ "system.Category" | translate }}
        </button>

        <button mat-button color="warn" class="delete" *ngIf="!isShowArchived; else showRestore"
                (click)="actionDelete(null)">
          <mat-icon>delete</mat-icon>
          {{ "system.delete" | translate }}
        </button>

        <ng-template #showRestore>
          <button mat-button color="primary" class="restore" (click)="actionRestore(null)">
            <mat-icon>unarchive</mat-icon>
            {{ "system.restore" | translate }}
          </button>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>

<mat-card class="content">
  <div class="categories-wrapper" [class.categories-empty]="sourcesCategories.length === 0" *ngIf="!isShowArchived">
    <mee-categories
      (refreshListAndCategoriesData)="onRefreshListAndCategoriesData()"
      (selectedItemsByCategoryChanged)="selectedItemsByCategoryChanged($event)"
      [list]="sources"
      [categories]="sourcesCategories"
    ></mee-categories>
  </div>

  <ng-container>
    <div class="table-content-wrapper" [class.with-categories]="sourcesCategories.length > 0">
      <as-split direction="horizontal" unit="pixel">
        <as-split-area minSize="210" maxSize="370" size="296">
          <div class="folders-wrapper">
            <mee-folders
              [preselectedItemMetadata]="selectedItemsMetadata"
              [folders]="folders"
              (selectedFolderChange)="onFolderChange($event)"
              (folderRenamed)="updateDataSources()"
              (itemsMoved)="updateDataSources()"
            ></mee-folders>
          </div>
        </as-split-area>
        <as-split-area>
          <div class="table-pagination-wrapper">
            <div class="table">
              <mat-table
                [dataSource]="dataSource"
                [matSortDisabled]="isDataLoading"
                [matSortDisableClear]="isDataLoading"
                (matSortChange)="onSortData($event)"
                matSortActive="CreatedAtUtc"
                matSortDirection="desc"
                matSort
              >
                <ng-container matColumnDef="Select">
                  <mat-header-cell *matHeaderCellDef [class.column-selected]="sourcesSelection.hasValue()">
                    <mat-checkbox
                      color="primary"
                      (change)="selectAll()"
                      [disabled]="isShowArchived"
                      [checked]="sourcesSelection.hasValue() && isAllSelected()"
                      [indeterminate]="sourcesSelection.hasValue() && !isAllSelected()"
                    ></mat-checkbox>
                  </mat-header-cell>

                  <mat-cell *matCellDef="let row" [class.column-selected]="sourcesSelection.hasValue()">
                    <mat-checkbox
                      color="primary"
                      [disabled]="isShowArchived"
                      (change)="onChangeSourceSelection($event, row)"
                      [checked]="sourcesSelection.isSelected(row)"
                      (click)="$event.stopPropagation()"
                    ></mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="IsProcessing">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <ng-container *ngIf="source.IsProcessing">
                      <img class="spinner" src="assets/img/icons/ellipse.png" alt=""/>
                      <mat-spinner diameter="10"></mat-spinner>
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Schedule">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <ng-container *ngIf="source.Schedule">
                      <ng-container *ngIf="source.Schedule.IsEnabled; else scheduleDisabled">
                        <img
                          (click)="navigateOnScheduleTab($event, source)"
                          [matTooltip]="getScheduleTooltipText(source.Schedule)"
                          class="alarm-clock"
                          src="assets/img/icons/alarm-clock.png"
                        />
                      </ng-container>

                      <ng-template #scheduleDisabled>
                        <img (click)="navigateOnScheduleTab($event, source)" class="alarm-clock"
                             src="assets/img/icons/alarm-clock(dis).png"/>
                      </ng-template>
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="MapParsingRules">
                  <mat-header-cell *matHeaderCellDef>
                    {{ "sources.mapping.scriptTabTitle" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <img
                      *ngIf="source.MapParsingRules"
                      (click)="navigateOnScheduleTab($event, source)"
                      class="lua-script"
                      [ngClass]="{ empty: !source.MapParsingRules }"
                      src="assets/img/icons/lua-script.png"
                    />
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CompanySlug">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.company" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    {{ source.CompanySlug }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Slug">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.identifier" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    {{ source.Slug }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Folder">
                  <mat-header-cell *matHeaderCellDef>
                    {{ "sources.listTable.columns.folder" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source" (click)="handleFolderClick($event, source.ParentFolderId)">
                    {{ source.ParentFolderName }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Description">
                  <mat-header-cell *matHeaderCellDef>
                    {{ "sources.listTable.columns.description" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <div>{{ source.Description }}</div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Type">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.source" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    {{ getSourceTitle(source.Type) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="IsRealTime">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <ng-container *ngIf="source.IsRealTime">
                      <span class="real-time" style="color: #66cc33">REAL-TIME</span>
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="TotalPlacemarks">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.total" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <div class="source-status">
                      {{ getPlacemarks(source.TotalPlacemarks) }}
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ProcessedPlacemarks">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.processed" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    {{ getPlacemarks(source.ProcessedPlacemarks) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ProcessedPercentage">
                  <mat-header-cell mat-sort-header *matHeaderCellDef> %</mat-header-cell>
                  <mat-cell *matCellDef="let source">
              <span [ngClass]="getProcessedClass(source.ProcessedPercentage)">
                {{ source.ProcessedPercentage === null ? "-" : source.ProcessedPercentage }}
              </span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Scope">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "teams.dtmTab.table.columns.visibility" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    <div class="visibility">
                      <ng-container [ngSwitch]="source.Scope">
                        <ng-container *ngSwitchCase="scope.CompanyScope">
                          <img src="./assets/img/icons/company-icon.svg" alt=""/>
                          <span>{{ "permissions.scope.company" | translate }}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="scope.TeamPublicScope">
                          <img src="./assets/img/icons/public.svg" alt=""/>
                          <span>{{ "permissions.scope.teamPublic" | translate }}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="scope.TeamPrivateScope">
                          <img src="./assets/img/icons/private.svg" alt=""/>
                          <span>{{ "permissions.scope.teamPrivate" | translate }}</span>
                        </ng-container>
                      </ng-container>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CreatedAtUtc">
                  <mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ "sources.listTable.columns.created" | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let source">
                    {{ source.CreatedAtUtc | date: "YYYY-MM-dd" }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row
                  [treeDrag]="{data: { Id: row.Id, Type: CollectionItemType.Datasource }}"
                  [treeDragEnabled]="true"
                  #ngxContextMenuRef="ngxContextMenu"
                  *matRowDef="let row; columns: displayedColumns;"
                  [contextMenu]="getContextMenu()"
                  [contextMenuValue]="row"
                  [class.selected]="sourcesSelection.isSelected(row)"
                  [class.deleted]="row.IsArchived || row.IsCascadeArchived"
                  [class.mocked]="isItemsMocked()"
                  (click)="this.actionMapping($event, row)"
                ></mat-row>
              </mat-table>
            </div>

            <mat-paginator
              [length]="totalCount"
              [disabled]="isDataLoading"
              [pageIndex]="pageIndex"
              [pageSize]="paginatorOptions.pageSize"
              [pageSizeOptions]="paginatorOptions.pageSizeOptions"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </ng-container>
</mat-card>

<div class="no-sources" *ngIf="!sources.length || isNoSourcesAfterDelete">
  <mee-stub [stubData]="stubData"></mee-stub>

  <button class="add-source--button" color="success" mat-raised-button [disabled]="!getIsCreatePermissionsAllowed()"
          (click)="actionAdd()">
    {{ "sources.listTable.topBar.addSource" | translate }}
  </button>
</div>

<context-menu #contextMenuRef menuClass="sources-context-menu">

  <ng-template [visible]="isMappingActionAvailable" contextMenuItem let-source>
    <a [routerLink]="getMappingRouterLink(source)">
      <div class="button-content edit">
        <mat-icon>settings_ethernet</mat-icon>
        {{ "system.mapping" | translate }}
      </div>
    </a>
  </ng-template>

  <ng-template [visible]="isEditActionAvailable" contextMenuItem let-source [disabled]="isEditActionDisabled">
    <a class="menu-item-href" [routerLink]="getEditRouterLink(source)" [queryParams]="{ tab: 'General' }">
      <div class="button-content edit">
        <mat-icon>edit</mat-icon>
        {{ "system.edit" | translate }}
      </div>
    </a>
  </ng-template>

  <ng-template [visible]="isArchiveActionAvailable" contextMenuItem (execute)="actionDelete($event)">
    <div class="button-content content">
      <mat-icon>archive</mat-icon>
      {{ "system.archive" | translate }}
    </div>
  </ng-template>

  <ng-template
    contextMenuItem
    [visible]="isRestoreActionAvailable"
    [disabled]="isRestoreActionDisabled"
    (execute)="actionRestore($event)"
    let-source
  >
    <div class="button-content content" [class.only-item]="source.IsCascadeArchived">
      <mat-icon>unarchive</mat-icon>
      {{ "system.restore" | translate }}
    </div>
  </ng-template>

</context-menu>
